import {
  BooleanOperator,
  DatetimeOperator,
  ListOperator,
  NumberOperator,
  StringOperator,
  Type,
} from './enums/builder-enums';
import {Property, WindowUnit} from './enums/expression-enums';
import {FilterOperator} from './types/builder-state-types';

export const LITERAL_NAMES = [
  `A`,
  `B`,
  `C`,
  `D`,
  `E`,
  `F`,
  `G`,
  `H`,
  `I`,
  `J`,
  `K`,
  `L`,
  `M`,
  `N`,
  `O`,
  `P`,
  `Q`,
  `R`,
  `S`,
  `T`,
  `U`,
  `V`,
  `W`,
  `X`,
  `Y`,
  `Z`,
];
export const DEFAULT_FREQUENCY_VALUE = 1;
export const ANY_EVENT = ``;
export const DEFAULT_EVENT = ANY_EVENT;

export const DEFAULT_RELATIVE_NUM_DAYS = 7;
export const DEFAULT_WINDOW_UNIT = WindowUnit.Day;

export const DEFAULT_PEOPLE_PROPERTY_OPTIONS = {
  operator: DatetimeOperator.Relative,
  property: `$created`,
  propertyType: Property.User,
  type: Type.Datetime,
  value: {
    window: {
      unit: WindowUnit.Day,
      value: 30,
    },
  },
};
export const MAX_LABEL_ENTRIES = 3;
export const FUNNEL_CLAUSE_OPERATOR: any = null;

export const DEFAULT_FILTER_OPERATOR: {[filter: string]: FilterOperator} = {
  [Type.String]: StringOperator.Equals,
  [Type.Number]: NumberOperator.EqualTo,
  [Type.Datetime]: DatetimeOperator.Relative,
  [Type.Boolean]: BooleanOperator.True,
  [Type.List]: ListOperator.Contains,
};
